import { useMemo } from "react";
import { useLang } from "@/lib/lang";
import DocumentViewer from "@/components/DocumentViewer";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export default function CitationSourceDialog({ open, onOpenChange, citation }) {
  const { t } = useLang();

  const highlightTarget = useMemo(() => {
    if (!citation) return null;
    return {
      page: citation.page,
      char_start: citation.char_start,
      excerpt: citation.excerpt,
    };
  }, [citation]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-4xl w-[95vw] h-[min(88vh,820px)] p-0 gap-0 rounded-none flex flex-col overflow-hidden"
        data-testid="citation-source-dialog"
      >
        <DialogHeader className="px-5 py-4 grid-border-b text-start shrink-0">
          <DialogTitle className="font-serif-display text-base text-slate-900 pe-8">
            {citation?.filename || t("citation")}
          </DialogTitle>
          {citation && (
            <DialogDescription className="text-xs text-slate-500">
              {t("citation")} {citation.source_id} · {t("viewer_page")} {citation.page}
            </DialogDescription>
          )}
        </DialogHeader>

        {citation?.excerpt && (
          <div
            className="px-5 py-3 grid-border-b bg-amber-50/60 text-sm text-slate-800 leading-relaxed shrink-0"
            dir="auto"
          >
            {citation.excerpt}
          </div>
        )}

        <div className="flex-1 min-h-0 overflow-hidden">
          {citation?.document_id ? (
            <DocumentViewer
              documentId={citation.document_id}
              highlightTarget={highlightTarget}
            />
          ) : (
            <div className="h-full flex items-center justify-center text-sm text-slate-400">
              {t("select_document")}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
